import { HTMLAttributes, memo } from "react";
import { useContent } from "../../../../../contexts/contentContext/contentContext";

import styles from "./styles.module.scss";
import { useSearchParams } from "react-router-dom";

interface SectionTitleI extends HTMLAttributes<HTMLDivElement> {
  titleTextKey: string;
  step: number;
}

const SectionTitle = memo(
  ({ titleTextKey, step, className, ...props }: SectionTitleI) => {
    const { getTextByKey } = useContent();
    const [searchParams] = useSearchParams();
    const errorReason = searchParams.get("reason");

    return (
      <div className={`${styles.sectionTitle} ${className || ""}`} {...props}>
        <div className={styles.stepCircle}>
          <span>{step}</span>
        </div>
        <h5>{getTextByKey(errorReason || titleTextKey)}</h5>
      </div>
    );
  }
);

export default SectionTitle;
